import PropTypes from 'prop-types'
import React, { Component } from 'react'
import parse from 'url-parse'
import { connect } from 'react-redux'
import ReactCSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'
import { SubmissionError } from 'redux-form'
import { Loader } from 'components/util'
import ualogo from 'images/ua-logo.png'
import * as auth from 'services/auth/selectors'
import * as authActions from 'services/auth/actions'
import * as site from 'services/site/selectors'
import * as migrateActions from 'services/migration/actions'

import MigrateForm from './MigrateForm'
import MigrateRequestSent from './MigrateRequestSent'
import styles from 'components/migration/_migrate.css'
import migrateHeader from 'images/migrate_header.jpg'

const mapStateToProps = (state, ownProps) => ({
  error: auth.selectError(state),
  loggingIn: auth.selectLoggingIn(state),
  dev: site.selectDev(state),
  user: state.user,
  chinaUserId: ownProps.params.chinaUserId,
  username: ownProps.params.username,
})

const mapDispatchToActions = {
  ...authActions,
  ...migrateActions,
}

export class Migrate extends Component {

  static propTypes = {
    loggingIn: PropTypes.bool,
    requestUser: PropTypes.func,
    confirmUser: PropTypes.func,
    login: PropTypes.func.isRequired,
    username: PropTypes.string,
    chinaUserId: PropTypes.string,
    clearLegacy: PropTypes.func.isRequired,
    dev: PropTypes.bool,
    user: PropTypes.object,
  };

  state = {
    submitting: false,
    error: null,
    loggedIn: false,
  }

  componentWillMount () {
    this.props.clearLegacy()
  }

  handleLogin = ({ email, password }) => {
    const { dev } = this.props

    this.setState({ submitting: true, error: null, userError: null })

    return this.props.login({ username: email, password }, true)
      .then(this.onLoginSuccess)
      .catch((err) => {
        this.setState({ submitting: false, loggedIn: false })
        if (err.user) {
          // there was a problem reloading user
          // the user is probably still logged in
          if (dev) {
            err.url = parse(err.config.url, true)
            this.setState({ userError: err })
          } else {
            this.setState({ error: 'unknown' })
          }
        } else if (err
          && err.response
          && err.response.data
          && err.response.data.error
          && err.response.data.error === 'access_denied'
        ) {
          throw new SubmissionError({ _error: err.response.data.error })
        } else {
          this.setState({ error: 'unknown' })
        }
      })
  }

  onLoginSuccess = () => {
    const { dev } = this.props
    this.setState({ submitting: false, loggedIn: true })
    this.props.requestUser(this.props.chinaUserId, this.props.username)
      .catch((err) => {
        this.setState({ submitting: false, loggedIn: false })
        if (err.user) {
          // there was a problem reloading user
          // the user is probably still logged in
          if (dev) {
            err.url = parse(err.config.url, true)
            this.setState({ userError: err })
          } else {
            this.setState({ error: 'unknown' })
          }
        } else if (err
          && err.response
          && err.response.data
          && err.response.data.includes('InvalidArgument: This account is not eligible to be migrated.')
        ) {
          this.setState({ error: 'NotEligible' })
        } else {
          this.setState({ error: 'unknown' })
        }
      })
  }

  getErrorMessage = (code) => {
    const messages = {
      'NotEligible': ('该账户不满足数据转移的条件。'),
      'unknown': ('发生未知错误，请再试一次。'),
    }

    if (code in messages) {
      return messages[code]
    }
  }

  render () {
    const { dev } = this.props
    const { submitting, error, userError, loggedIn } = this.state

    return (
      <div className={styles.container}>
        <div>
          <img src={migrateHeader} className={styles.headerImage} />
          <img src={ualogo} className={styles.icon} />
          {loggedIn ?
            <MigrateRequestSent
              email={this.props.user.email}
            />
          :
            <div>
              <h2 className={styles.title}>
                转移锻炼
              </h2>
              <p className={styles.migrateParagraph}>
                此操作可一次性将您的锻炼数据从UA MapMyRun转移至您的新UA Run账户。
              </p>
              <p className={styles.migrateParagraph}>
                一旦开始使用应用，您将无法从UA MapMyRun中继续同步数据。将锻炼数据转至UA Run后，您的UA MapMyRun账户将会停用。
              </p>
              <ReactCSSTransitionGroup
                component='div'
                transitionName='fade'
                transitionEnterTimeout={300}
                transitionLeaveTimeout={300}
                >
                {submitting ?
                  <div key='loader'>
                    <div className={styles.loader}>
                      <Loader height={50} width={50} />
                    </div>
                  </div>
                  : null}
              </ReactCSSTransitionGroup>

              {error ?
                <div className={styles.error}>
                  {this.getErrorMessage(error)}
                </div>
              : null}

              <MigrateForm
                loggingIn={submitting}
                onSubmit={this.handleLogin}
                confirmPage={false}
              />
            </div>
          }
        </div>
        {/*
          DEBUG information, only shown in local/devint
          Useful because DEVINT endpoints are often troublesome
        */}
        {userError && dev ?
          <div className={styles.userError}>
            <div className={styles.userErrorDescription}>
              You were logged in successfully, however there was an error fetching your user data.
              Feel free to try again, or just proceed to <a href="/my_home">my home</a>.
            </div>
            <div className={styles.userErrorMessage}>
              {userError.toString()} <br />
              {userError.response.status === 502 && 'Bad Gateway, server may be down or restarting'}
              {userError.response.status === 503 && 'Service Unavailable, server may be down or restarting'}
              {userError.response.status === 504 && 'Gateway Timeout, server took too long'}
            </div>
            <div><b>Host: </b>{userError.url.host}</div>
            <div><b>Path: </b>{userError.url.pathname}</div>
          </div>
        : null}
      </div>
    )
  }

}

export default connect(mapStateToProps, mapDispatchToActions)(Migrate)
